// userSlice.js
import { createSlice } from '@reduxjs/toolkit';

const getInitialUser = () => {
  try {
    const savedUser = localStorage.getItem("user");
    return savedUser ? JSON.parse(savedUser) : null;
  } catch (e) {
    return null;
  }
};

const token = localStorage.getItem("token");

const userSlice = createSlice({
  name: 'user',
  initialState: {
    isAuthenticated: !!token,
    user: getInitialUser(),
  },
  reducers: {
    setLogin(state, action) {
      state.isAuthenticated = true;
      state.user = action.payload;
      if (action.payload) {
        localStorage.setItem("user", JSON.stringify(action.payload));
      }
    },
    setUserProfile(state, action) {
      state.user = action.payload;
      if (action.payload) {
        const currentUser = getInitialUser() || {};
        const updatedUser = { ...currentUser, ...action.payload };
        localStorage.setItem("user", JSON.stringify(updatedUser));
      }
    },
    logout(state) {
      state.isAuthenticated = false;
      state.user = null;
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("token_expiry");
      localStorage.removeItem("pos_id");
    },
  },
});

export const { setLogin, logout, setUserProfile } = userSlice.actions;
export default userSlice.reducer;